import React, { FC } from 'react';
import CiaInputsGroup from '@components/EntityDrawers/components/CiaInputsGroup';
import IncludeInReportSwitch from '@components/EntityDrawers/components/IncludeInReportSwitch';
import DesignEffectivenessDropdown from '@components/EntityDrawers/components/inputs/DesignEffectivenessDropdown';
import OperationalEffectivenessDropdown from '@components/EntityDrawers/components/inputs/OperationalEffectivenessDropdown';
import OperationalModelDropdown from '@components/EntityDrawers/components/inputs/OperationalModelDropdown';
import OperationalStatusRadioGroup from '@components/EntityDrawers/components/inputs/OperationalStatusRadioGroup';
import PartnersList from '@components/EntityDrawers/components/inputs/PartnersList';
import TimelineDates from '@components/EntityDrawers/components/inputs/TimelineDates';
import AuditFindingGroup from '@components/EntityDrawers/drawers/Component/inputs/AuditFindingGroup';
import ImplementationGuidance from '@components/EntityDrawers/drawers/Component/inputs/ImplementationGuidance';

const Advanced: FC = () => {
  return (
    <>
      <IncludeInReportSwitch />
      <OperationalStatusRadioGroup />
      <TimelineDates />
      <AuditFindingGroup />
      <CiaInputsGroup />
      <ImplementationGuidance />
      <DesignEffectivenessDropdown />
      <OperationalEffectivenessDropdown />
      <OperationalModelDropdown />
      <PartnersList />
    </>
  );
};

export default Advanced;
